import z from "zod";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";

export const useProfileFormSchema = () => {
  const { t } = useTranslation();

  const profileFormSchema = useMemo(() => {
    return z.object({
      fullName: z
        .string()
        .trim()
        .min(4, { message: t("error_full_name") }),
      email: z.string(),

      phoneNumber: z
        .string()
        .regex(/^(?:$|\+[0-9]{7,15})$/, {
          message:
            "Phone number must start with + or 00 and contain 7–15 digits",
        })
        .optional()
        .nullable()
        .default(""),

      publicUrl: z
        .string()
        .optional()
        .refine(
          (val) => {
            if (!val) return true; // allow undefined or empty string
            if (val.trim() === "") return true; // allow empty string
            const urlPattern =
              /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}.*$/;
            return urlPattern.test(val);
          },
          { message: "Invalid URL format" }
        ),

      brandName: z
        .string()

        .optional(),

      brandLogo: z
        .string()

        .optional(),

      brandTone: z
        .string()

        .optional(),

      audienceAgeRange: z
        .array(z.string().min(1))

        .optional(),

      audienceGender: z
        .string()

        .optional(),

      audienceRegions: z
        .array(z.string().min(1))

        .optional(),

      audienceInterests: z.array(z.string().min(1)).optional(),

      audienceSegments: z.array(z.string().min(1)).optional(),

      contentCategories: z.array(z.string().min(1)).optional(),

      preferredPlatforms: z.array(z.string().min(1)).optional(),

      primaryPurpose: z.array(z.string().min(1)).optional(),

      keyOutcomes: z.array(z.string().min(1)).optional(),

      postingStyle: z.string().optional(),
      isBrandLogo: z.boolean().optional(),
      isBrandTheme: z.boolean().optional(),
    });
  }, [t]);

  return profileFormSchema;
};

export type ProfileFormData = z.infer<ReturnType<typeof useProfileFormSchema>>;
